// extracted by mini-css-extract-plugin
export default {"wrapper":"error-view-module__wrapper","msgBlock":"error-view-module__msgBlock","errorImg":"error-view-module__errorImg","errorMsg":"error-view-module__errorMsg"};